import React, { PropTypes, Component } from 'react';
import Portal from 'components/Portal';

export default class DialogPortal extends Component {
  static displayName = 'DialogPortal';

  render() {
    return (
      <Portal style={{ zIndex: 100, position: 'relative' }}>
        {this.props.children}
      </Portal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/DialogPortal.js